import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-card", [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleClickQueryButton.apply(null, arguments);
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.quoteNo")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("inquiryList.erpRequestPriceKeywordPH")
    },
    model: {
      value: _vm.queryParam.condition.orderKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "orderKeyword", $$v);
      },
      expression: "queryParam.condition.orderKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.erpCustomerKeyword")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("inquiryList.erpCustomerKeywordPH")
    },
    model: {
      value: _vm.queryParam.condition.customerKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "customerKeyword", $$v);
      },
      expression: "queryParam.condition.customerKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.sellerCode")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      options: _vm.sellerList,
      placeholder: _vm.$t("inquiryList.sellerCodePH"),
      mode: "multiple",
      maxTagCount: 1
    },
    model: {
      value: _vm.queryParam.condition.sellerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "sellerCode", $$v);
      },
      expression: "queryParam.condition.sellerCode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.quoteTime")
    }
  }, [_c("date-range", {
    staticClass: "middleClass",
    attrs: {
      endDate: _vm.queryParam.condition.endDate,
      startDate: _vm.queryParam.condition.startDate
    },
    on: {
      change: _vm.handleDateChange
    }
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.deliveryMethod")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.deliveryWays,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "deliveryWays", $$v);
      },
      expression: "queryParam.condition.deliveryWays"
    }
  }, _vm._l(_vm.deliveryMethodList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.amount")
    }
  }, [_c("a-input-group", {
    attrs: {
      compact: ""
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "42%",
      "text-align": "center"
    },
    attrs: {
      allowClear: "",
      min: 1
    },
    model: {
      value: _vm.queryParam.condition.startTotalAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "startTotalAmount", $$v);
      },
      expression: "queryParam.condition.startTotalAmount"
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "16%",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "42%",
      "text-align": "center"
    },
    attrs: {
      allowClear: "",
      min: 1
    },
    model: {
      value: _vm.queryParam.condition.endTotalAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "endTotalAmount", $$v);
      },
      expression: "queryParam.condition.endTotalAmount"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 12,
      sm: 24
    }
  }, [_c("a-col", {
    staticClass: "button-wrapper",
    attrs: {
      span: 24
    }
  }, [_c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleClickQueryButton
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")])], 1)], 1)], 1)], 1)], 1)], 1), _c("a-card", {
    staticClass: "table-wrapper"
  }, [_c("a-row", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.syncErpRequestPriceFuc
    }
  }, [_vm._v(_vm._s(_vm.$t("inquiryList.syncQuote")))])], 1)], 1), _c("a-table", {
    attrs: {
      loading: _vm.tableLoading,
      columns: _vm.columns,
      dataSource: _vm.tableData,
      pagination: {
        "show-quick-jumper": true,
        "show-size-changer": true,
        showTotal: function showTotal(total) {
          return "".concat(_vm.$t("public.total"), "\uFF1A").concat(total);
        },
        total: _vm.total,
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size
      }
    },
    on: {
      change: _vm.hangeTableChange
    },
    scopedSlots: _vm._u([{
      key: "askPriceNo",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/quoteDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.orderNo) + " ")])], 1);
      }
    }, {
      key: "erpCustomerName",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/customermanager/editcustomer2",
              query: {
                erpCustomerId: record.customerId
              }
            }
          }
        }, [_c("div", [_vm._v(_vm._s(text))]), _c("div", [_vm._v(_vm._s(record.erpCustomerCode))])])], 1);
      }
    }, {
      key: "totalAmountTitle",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(_vm.$t("inquiryList.amount")) + " "), _c("div", [_vm._v(_vm._s(_vm.$t("orderList.payId")))])]);
      }
    }, {
      key: "totalAmount",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_vm._v(" " + _vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm.toThousandslsFilter(record.totalAmount)) + _vm._s(_vm.rightCurrencySymbol + (record.taxList ? _vm.$t("orderList.suiru") : _vm.$t("orderList.suiba"))) + " ")]), _vm._v(" " + _vm._s(record.payTitle) + " ")]);
      }
    }, {
      key: "orderDate",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(text) + " ")]);
      }
    }, {
      key: "editno",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(text) + " ")]);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          attrs: {
            target: "_blank",
            to: {
              path: "/quoteDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("inquiryList.detail")) + " ")])], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };